export default "__VITE_ASSET__cbf29a83__"